import React from 'react';
import { T } from 'shared/helper/translate';
import DigitalEditingUniques from './DigitalEditingUniques';
var DigitalEditingOverview = function DigitalEditingOverview() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "digital-editing-intro-heading"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-overview"
  }), /*#__PURE__*/React.createElement(DigitalEditingUniques, null));
};
export default DigitalEditingOverview;